<template>
  <div class="row text-start">
    <div v-if="error" class="alert alert-danger">
      {{ error }}
    </div>
    <div class="col-md-4 col-xs-6">
      <div class="form-floating mb-3">
        <input type="number" class="form-control" id="start" v-model="start" />
        <label for="start">از شماره صندلی:</label>
      </div>
    </div>

    <div class="col-md-4 col-xs-6">
      <div class="form-floating mb-3">
        <input type="number" class="form-control" id="end" v-model="end" />
        <label for="end">تا شماره صندلی:</label>
      </div>
    </div>

    <div class="col-md-4 col-xs-6">
      <div class="form-floating mb-3">
        <input
          type="number"
          class="form-control"
          id="price"
          v-model="price"
          v-on:keyup.enter="addProductToPackage"
        />
        <label for="price">قیمت</label>
      </div>
    </div>

    <div class="col-md-12 col-xs-12">
      <label for="description">توضیحات</label>
      <textarea
        type="text"
        class="form-control"
        id="description"
        v-model="description"
      >
      </textarea>
    </div>

    <div class="col-md-4 col-xs-6">
      <button
        class="btn btn-primary mt-0 mt-md-3"
        @click="addChairs"
        :disabled="loading"
      >
        افزودن
        <span v-if="loading">
          <i class="fas fa-spinner fa-spin"></i>
        </span>
      </button>
    </div>
  </div>
</template>

<script>
import ArefApi from "../../../libs/api.js";
import utils from "../../../libs/utils.js";

export default {
  name: "AddChairs",
  props: {
    productId: {
      type: Number,
      required: true,
    },
  },
  emits:{
      refreshList:String
  },
  created: function () {
    this.utils = new utils();
    this.arefApi = new ArefApi(this);
  },

  data() {
    return {
      error: null,
      start: null,
      end: null,
      price: null,
      description: null,
      loading: false,
    };
  },
  methods: {
    addChairs() {
      if (!this.validateAddInputs()) {
        return;
      }
      this.loading = true;
      const chairsData = {
        products_id: this.productId,
        start: this.start,
        end: this.end,
        price: this.price,
        description: this.description,
      };
      this.arefApi
        .addChairs(chairsData)
        .then(() => {
          this.$emit("refreshList");
          this.utils.showSuccess(this);
        })
        .catch((err) => {
          this.utils.showErrors(this, err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    validateAddInputs() {
      this.error = null;
      if (!this.start || +this.start < 0 || +this.start >= +this.end) {
        this.error = "عدد شروع صندلی را صحیح وارد کنید";
        return false;
      }

      if (!this.end || +this.end < 0) {
        this.error = "عدد پایان صندلی را صحیح وارد کنید";
        return false;
      }

      if (!this.price || +this.price <= 0) {
        this.error = "قیمت را صحیح وارد کنید";
        return false;
      }

      return true;
    },
  },
};
</script>